import { Model } from '@models'
import SUBMIT_HEALTH_METRICS from '../graphql/submitHealthMetrics'
import FETCH_HEALTH_METRICS from '../graphql/fetchHealthMetrics'
import DELETE_HEALTH_METRIC from '../graphql/deleteHealthMetric'
import CREATE_HEALTH_METRIC from '../graphql/createHealthMetric'
import UPDATE_HEALTH_METRIC from '../graphql/updateHealthMetric'
import FETCH_LAB_RESULTS from '../graphql/fetchLabResults'
import FETCH_LAB_RESULT from '../graphql/fetchLabResult'
import DELETE_LAB_RESULT from '../graphql/deleteLabResult'
import CREATE_LAB_RESULT_FROM_UPLOAD from '../graphql/createLabResultFromUpload'
import reducers from './labResults.reducers'

export default class LabResults {
  namespace = 'labResults'

  state = {
    ...Model.defaultState,
    healthMetrics: null,
    labResults: null,
  }

  effects = {
    submit: Model.buildEffect({
      name: `${this.namespace}/submit`,
      query: SUBMIT_HEALTH_METRICS,
      caching: false,
      dataPath: 'submitLabResults',
    }),
    fetchHealthMetrics: Model.buildEffect({
      name: `${this.namespace}/fetchHealthMetrics`,
      query: FETCH_HEALTH_METRICS,
      caching: false,
      dataPath: 'healthMetrics',
      reducers: [{ name: 'updateHealthMetrics' }],
    }),
    deleteHealthMetric: Model.buildEffect({
      name: `${this.namespace}/deleteHealthMetric`,
      query: DELETE_HEALTH_METRIC,
      caching: false,
      dataPath: 'deleteHealthMetric',
    }),
    createHealthMetric: Model.buildEffect({
      name: `${this.namespace}/createHealthMetric`,
      query: CREATE_HEALTH_METRIC,
      caching: false,
      dataPath: 'createHealthMetric',
    }),
    updateHealthMetric: Model.buildEffect({
      name: `${this.namespace}/updateHealthMetric`,
      query: UPDATE_HEALTH_METRIC,
      caching: false,
      dataPath: 'updateHealthMetric',
    }),
    fetchLabResults: Model.buildEffect({
      name: `${this.namespace}/fetchLabResults`,
      query: FETCH_LAB_RESULTS,
      caching: false,
      dataPath: 'labResults',
      reducers: [{ name: 'updateLabResults' }],
    }),
    fetchLabResult: Model.buildEffect({
      name: `${this.namespace}/fetchLabResult`,
      query: FETCH_LAB_RESULT,
      caching: false,
      dataPath: 'labResult',
      reducers: [
        {
          name: 'updateListItem',
          storePath: 'labResults.labResults',
          dataPath: 'labResult',
        },
      ],
    }),
    deleteLabResult: Model.buildEffect({
      name: `${this.namespace}/deleteLabResult`,
      query: DELETE_LAB_RESULT,
      caching: false,
      dataPath: 'deleteLabResult',
    }),
    createLabResultFromUpload: Model.buildEffect({
      name: `${this.namespace}/createLabResultFromUpload`,
      query: CREATE_LAB_RESULT_FROM_UPLOAD,
      caching: false,
      dataPath: 'createLabResultFromUpload',
    }),
  }

  reducers = reducers
}
